export default {
  menu: {
    grimoire: {
      title: "Grimoire",
      hide: "Hide",
      show: "Show",
      switchToNight: "Switch to Night",
      switchToDay: "Switch to Day",
      nightOrder: "Night order",
      zoom: "Zoom",
      backgroundImage: "Background image",
      showCustomImages: "Show Custom Images",
      disableAnimations: "Disable Animations",
      muteSounds: "Mute Sounds",
      language: "Language",
    },
    session: {
      title: "Live Session",
      hosting: "Hosting",
      playing: "Playing",
      hostST: "Host (Storyteller)",
      joinPlayer: "Join (Player)",
      delayToHost: "Delay to host",
      delayToPlayers: "Delay to players",
      ms: "ms",
      copyPlayerLink: "Copy player link",
      sendCharacters: "Send Characters",
      voteHistory: "Vote history",
      leaveSession: "Leave Session",
    },
    players: {
      title: "Players",
      add: "Add",
      randomize: "Randomize",
      removeAll: "Remove all",
    },
    characters: {
      title: "Characters",
      selectEdition: "Select Edition",
      chooseAssign: "Choose & Assign",
      addFabled: "Add Fabled",
      removeAll: "Remove all",
      clearReminders: "Clear reminders",
      syncState: "Sync state to players",
    },
    help: {
      title: "Help",
      referenceSheet: "Reference Sheet",
      nightOrderSheet: "Night Order Sheet",
      gameStateJson: "Game State JSON",
      joinDiscord: "Join Discord",
      sourceCode: "Source code",
    },
    tooltips: {
      nomination:
        "0 recent nominations | 1 recent nomination | {count} recent nominations",
      sessionPlayers: "{count} other players in this session",
      sessionPlayersLatency:
        "{count} other players in this session ({ping}ms latency)",
    },
    prompts: {
      backgroundUrl: "Enter custom background URL",
      hostSession: "Enter a channel number / name for your session",
      joinSession:
        "Enter the channel number / name of the session you want to join",
      playerName: "Player name",
    },
    confirms: {
      distributeRoles:
        "Do you want to distribute assigned characters to all SEATED players?",
      customImages:
        "Are you sure you want to allow custom images? A malicious script file author might track your IP address this way.",
      randomizeSeats: "Are you sure you want to randomize seatings?",
      removePlayers: "Are you sure you want to remove all players?",
      removeRoles: "Are you sure you want to remove all player roles?",
      clearReminders: "Clear all reminder tokens for all players?",
      syncState:
        "Sync your full grimoire state (roles, reminders, gamestate) to all players?",
      leaveSession: "Are you sure you want to leave the active live game?",
    },
  },
  player: {
    handUp: "Hand UP",
    handDown: "Hand DOWN",
    cancel: "Cancel",
    swapSeats: "Swap seats with this player",
    moveToSeat: "Move player to this seat",
    nominate: "Nominate this player",
    ghostVote: "Ghost vote",
    menu: {
      changePronouns: "Change Pronouns",
      rename: "Rename",
      move: "Move player",
      swap: "Swap seats",
      remove: "Remove",
      emptySeat: "Empty seat",
      nomination: "Nomination",
      claimSeat: "Claim seat",
      vacateSeat: "Vacate seat",
      seatOccupied: "Seat occupied",
    },
    prompts: {
      pronouns: "Player pronouns",
      rename: "Player name",
    },
  },
  townSquare: {
    otherCharacters: "Other characters",
    demonBluffs: "Demon bluffs",
    fabled: "Fabled",
    confirms: {
      removePlayer: "Do you really want to remove {name}?",
    },
  },
  townInfo: {
    addMorePlayers: "Please add more players!",
  },
  intro: {
    welcome:
      "Welcome to the (unofficial) Virtual Town Square and Grimoire for Blood on the Clocktower!",
    addPlayers: "Please add more players through the",
    joinSession: "You can also join a game session by pressing",
    footer:
      'This project is free and open source and can be found on GitHub. It is not affiliated with The Pandemonium Institute. "Blood on the Clocktower" is a trademark of Steven Medway and The Pandemonium Institute.',
    chineseVersion: "你想使用中文版魔典吗?",
  },
  vote: {
    nominated: "{nominator} nominated {nominee}!",
    voteCount: "0 votes in favor | 1 vote in favor | {count} votes in favor",
    majority: "(majority is {count})",
    timePerPlayer: "Time per player:",
    countdown: "Countdown",
    start: "Start",
    restart: "Restart",
    pause: "Pause",
    resume: "Resume",
    reset: "Reset",
    close: "Close",
    markExecution: "Mark for execution",
    clearMark: "Clear mark",
    secondsBetweenVotes: "{seconds} seconds between votes",
    handDown: "Hand DOWN",
    handUp: "Hand UP",
    claimSeatToVote: "Please claim a seat to vote.",
    go: "GO",
  },
  teams: {
    townsfolk: "Townsfolk",
    outsider: "Outsiders",
    minion: "Minions",
    demon: "Demon",
    traveler: "Travellers",
    fabled: "Fabled",
  },
  modals: {
    edition: {
      selectEdition: "Select an edition:",
      customScript: "Custom Script / Characters",
      loadCustomScript: "Load custom script / characters",
      instructions:
        'To play with a custom script, you need to select the characters you want to play with in the official Script Tool and then upload the generated "custom-list.json" either directly here or provide a URL to such a hosted JSON file.',
      scriptToolLink: "Script Tool",
      customCharsInstructions:
        "To play with custom characters, please read the documentation on how to write a custom character definition file.",
      customCharsLink: "Custom Characters",
      warning: "Only load custom JSON files from sources that you trust!",
      popularScripts: "Some popular custom scripts:",
      uploadJson: "Upload JSON",
      enterUrl: "Enter URL",
      useClipboard: "Use JSON from Clipboard",
      back: "Back",
      prompts: {
        enterUrl: "Enter URL to a custom-script.json file",
      },
      errors: {
        reading: "Error reading custom script: ",
        loading: "Error loading custom script: ",
      },
    },
    fabled: {
      chooseCharacter: "Choose a fabled character to add to the game",
    },
    gameState: {
      title: "Current Game State",
      copyJson: "Copy JSON",
      loadState: "Load State",
      errors: {
        parseJson: "Unable to parse JSON: ",
      },
    },
    nightOrder: {
      title: "Night Order",
      customScript: "Custom Script",
      firstNight: "First Night",
      otherNights: "Other Nights",
      minionInfo: "Minion info",
      minionInfoText:
        '• If more than one Minion, they all make eye contact with each other. • Show the "This is the Demon" card. Point to the Demon.',
      demonInfo: "Demon info & bluffs",
      demonInfoText:
        '• Show the "These are your minions" card. Point to each Minion. • Show the "These characters are not in play" card. Show 3 character tokens of good characters not in play.',
      showReference: "Show Character Reference",
    },
    reference: {
      title: "Character Reference",
      customScript: "Custom Script",
      jinxed: "Jinxed",
      showNightOrder: "Show Night Order",
    },
    reminder: {
      chooseToken: "Choose a reminder token:",
      good: "Good",
      evil: "Evil",
      customNote: "Custom note",
      prompts: {
        customNote: "Add a custom reminder note",
      },
    },
    role: {
      chooseForPlayer: "Choose a new character for {name}",
      chooseForBluff: "Choose a new character for bluffing",
      editionRoles: "Edition Roles",
      otherTravelers: "Other Travelers",
    },
    roles: {
      selectCharacters: "Select the characters for {count} players:",
      warning:
        "Warning: there are characters selected that modify the game setup! The randomizer does not account for these characters.",
      allowDuplicates: "Allow duplicate characters",
      assignRoles: "Assign {count} characters randomly",
      shuffleCharacters: "Shuffle characters",
    },
    voteHistory: {
      title: "Vote history",
      time: "Time",
      nominator: "Nominator",
      nominee: "Nominee",
      type: "Type",
      votes: "Votes",
      majority: "Majority",
      voters: "Voters",
      accessibleToPlayers: "Accessible to players",
      clearForEveryone: "Clear for everyone",
      clearHistory: "Clear vote history",
    },
  },
};
